import { __decorate, __extends, __metadata } from "tslib";
import ValueObject from '../ValueObject';
import { Date as DateAttribute } from '../Decorators';
import NeoModel from '../NeoModel';
var AuditValuesBase = /** @class */ (function (_super) {
    __extends(AuditValuesBase, _super);
    function AuditValuesBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createdBy = 0;
        _this.createdOn = new Date();
        _this.modifiedBy = 0;
        _this.modifiedOn = new Date();
        return _this;
    }
    // Client only properties / methods
    AuditValuesBase.prototype.addBusinessRules = function (rules) {
        _super.prototype.addBusinessRules.call(this, rules);
    };
    AuditValuesBase.prototype.toString = function () {
        if (this.isNew) {
            return "New audit values";
        }
        else {
            return "Audit Values";
        }
    };
    __decorate([
        DateAttribute(),
        __metadata("design:type", Date)
    ], AuditValuesBase.prototype, "createdOn", void 0);
    __decorate([
        DateAttribute(),
        __metadata("design:type", Date)
    ], AuditValuesBase.prototype, "modifiedOn", void 0);
    return AuditValuesBase;
}(ValueObject));
export { AuditValuesBase };
var AuditValues = /** @class */ (function (_super) {
    __extends(AuditValues, _super);
    function AuditValues() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuditValues = __decorate([
        NeoModel
    ], AuditValues);
    return AuditValues;
}(AuditValuesBase));
export { AuditValues };
